import { Spacer } from '@oy/uidesktop';
import { useSelector } from 'react-redux';
import { useCheckMAMViewOnlyChildType, useEnv } from 'src/hooks';
import { RootState } from 'src/redux/reducers/rootReducer';
import styles from '../Sidebar.module.css';
import { ApiKeyStagingComponent } from './ApiKeyStagingComponent';
import ApiRequestWidget from './ApiRequestWidget';
import { useApiMenuItemImpl } from './useApiMenuItemImpl';

const ApiKeyMenuItem = () => {
  const { isProdEnv } = useEnv();
  const { isViewOnlyChildActive } = useCheckMAMViewOnlyChildType();
  const apiKeyStaging = useSelector(
    (state: RootState) => state.auth.apiKeyStaging,
  );
  const { onClickCopyButton } = useApiMenuItemImpl();

  return (
    <>
      {!isViewOnlyChildActive &&
        (isProdEnv ? (
          <ApiRequestWidget />
        ) : (
          <>
            <Spacer
              top={Spacer.Size.XL}
              bottom={Spacer.Size.M}
              className={styles.apiKeyStagingDivider}
            />
            <ApiKeyStagingComponent
              apiKeyStaging={apiKeyStaging}
              onClickCopyButton={onClickCopyButton}
            />
          </>
        ))}
    </>
  );
};

export default ApiKeyMenuItem;
